<script setup lang="ts">
import AuditTable from "@/components/AuditTable.vue";
import LoadingModal from "@/components/LoadingModal.vue";
import useRoleLog from "@/modules/roles/composables/useRoleLog.ts";
import { Role } from "@/modules/roles/composables/useRoles.ts";

interface Props {
  role: Role;
}

const props = defineProps<Props>();

const { page, setPage, logs, refetch, pagination, isLoading } = useRoleLog({
  params: {
    id: props.role.id,
  },
  immediate: true,
});
</script>

<template>
  <div class="w-full">
    <AuditTable
      :logs="logs || []"
      :pagination="pagination!"
      :page="page"
      @search="refetch"
      @set-page="setPage"
      classTable="w-full"
    />
  </div>

  <LoadingModal :when="isLoading" />
</template>

<style scoped></style>
